const transferPolicy = {
  DEFAULT: 'DEFAULT',
  TED_WHEN_POSSIBLE: 'TED_WHEN_POSSIBLE',
  TED_ONLY: 'TED_ONLY',
  TEV_ONLY: 'TEV_ONLY',
  PIX_ONLY: 'PIX_ONLY'
};

module.exports = transferPolicy;
